// extracted by mini-css-extract-plugin
export default {"section":"goods-subscriptions_section__tRBWs","title":"goods-subscriptions_title__aYCIN","wrapper":"goods-subscriptions_wrapper__LrQ8T"};